// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19DFY","select":"styles_select__Xx66X"};